/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Theme adapter for recent activity page updates
namespace('Slzr.Theme.RecentActivity', function(exports, top) {
  let jQuery;
  const $ = (jQuery = top.Slzr.jQuery);

  // Add item to the recent activity list
  //
  // options has:
  //   container: dom id (prefix) of listing
  //   item: rendered html for the item row
  exports.addItem = function(options) {
    const {
      container
    } = options;
    const {
      item
    } = options;

    $(`#${container}_list`).append(item);
    return $(`#${container}_list .em-recent-activity-nocontent`).remove();
  };

  // Remove an item from the recent activity list
  //
  // options:
  //   container: dom id (prefix) of listing
  //   item: id of element to remove (no leading #)
  exports.removeItem = function(options) {
    const {
      container
    } = options;
    const {
      item
    } = options;

    return $(`#${item}`).remove();
  };


  // Select reaction
  exports.selectReaction = function(element) {
    const $element = $(element);
    return $element.addClass('em-active');
  };

  // Clear reactions
  exports.clearReactions = form => $(form).find('[data-reaction]').removeClass('em-active');

  // Append more activity to the bottom of the list
  exports.appendActivity = data => $(`#${  data.container}`).append(data.content);

  exports.updateMoreActivityLink = data => $(`#${  data.id}`).html(data.content);


  // Attach form event handlers
  return jQuery(function($) {
    // Attach reaction selection handler
    $('form[data-recent-activity] [data-reaction]').on('click', function(event) {
      event.preventDefault();
      const $element = $(this);
      const $form = $element.closest('form');
      exports.clearReactions($form);
      return exports.selectReaction($element);
    });

    // Validate form on submit, and direct to the appropriate action for review or comment
    $('form[data-recent-activity]').on('submit', function(event, data) {
      let new_action;
      const $form = $(this);
      const comment = $form.find('textarea');

      if (comment.attr('data-validation') === undefined) {
        if (comment.val().isBlank()) {
          alert('You must provide a comment!');
          event.stopPropagation();
          event.preventDefault();
        }
      }

      const $terms_checkbox = $form.find('[name="accept_terms"]');
      
      if ($terms_checkbox.attr('data-validation') === undefined) {      
        if (!$terms_checkbox.prop('checked')) {
          alert('You must accept the terms and conditions');
          event.stopPropagation();
          event.preventDefault();
        }
      }

      // Rewrite the form's target if a reaction is provided
      //
      // TODO: Remove this once comments/reviews are unified on the backend
      const selected_reactions = $form.find('[data-reaction].em-active');
      if (selected_reactions.length > 0) {
        // It's a review
        new_action = $form.attr('action').replace('comment', 'review');

        // And update the rating based on the reaction selected
        const new_rating = (() => { switch (selected_reactions.data('reaction')) {
          case 'up': case 'heart': case 'laugh': return 1;
          case 'down': case 'sad': case 'angry': return -1;
          default: return 0;
        } })();
        $form.find('input[name="rating"]').val(new_rating);
      } else {
        // It's a comment
        new_action = $form.attr('action').replace('review', 'comment');
      }

      return $form.attr('action', new_action);
    });

    // Reset form state after successful submission
    return $(document).on('ajax:success', 'form[data-recent-activity]', function(ev, data) {
      const form = $(ev.target);

      form.find('input[type="text"], textarea').val(null);
      form.find('input[type="radio"], input[type="checkbox"]').prop('checked', false);
      form.find('input[type="submit"]').each(function() {
        const $this = $(this);
        $this.prop('disabled', false);
        let original_value = $this.attr('originalValue');
        if (!original_value) { original_value = $this.data('ujs:enable-with'); }
        if (original_value != null) { return $this.val(original_value); }
      });

      return exports.clearReactions(form);
    });
  });
});
